// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { UpdateAssociationBindingAdmin, UpdateAssociationBindingAdminSchema } from 'api/gen/UpdateAssociationBindingAdmin';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateAssociationBindingAdminBaseObject, ValidateAssociationBindingAdminBaseObjectSchema } from 'api/gen/ValidateAssociationBindingAdminBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateUpdateAssociationBindingAdmin'),
  binding: t.union([UpdateAssociationBindingAdminSchema, t.null]),
});

export const ValidateUpdateAssociationBindingAdminSchema = excess(t.intersection([ValidateAssociationBindingAdminBaseObjectSchema.type, requiredPart]));

export interface ValidateUpdateAssociationBindingAdmin extends t.TypeOf<typeof ValidateUpdateAssociationBindingAdminSchema> {}
